(function(){
    angular
        .module('maApp.error')
        .factory('$exceptionHandler', $exceptionHandler);

    $exceptionHandler.$inject = [];

    function $exceptionHandler(){

        var errorTypesToReport = ['RequestError'];

        return handler;

        function handler(exception){
            if(errorTypesToReport.indexOf(exception.name) >= 0){
                var event = new CustomEvent('maApp.exception', {'detail':exception});
                document.dispatchEvent(event);
            }
        }

    }
})();